function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-8156 4147a10.01 10.01 0 0 1-10-10 10.01 10.01 0 0 1 10-10 10.01 10.01 0 0 1 10 10 9.94 9.94 0 0 1-2.928 7.071A9.94 9.94 0 0 1-8156 4147m-5.443-11.708-1.146 1.635 7.168 4.507 5.831-8.034-1.894-1.242-4.679 6.359-5.281-3.226Z",
    "data-name": "Exclusion 39",
    style: {
      fill: "#fff"
    },
    transform: "translate(8166 -4127)"
  }));
};
export default SvgSuccess;